// src/components/NoticeLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import SubLayout from "./SubLayout.jsx";
import NavTabs from "./NavTabs.jsx";     // ✅ 기존 탭 컴포넌트 재사용

/**
 * Hero + 탭(공지사항/자주묻는 질문)을 포함한 레이아웃
 * - 탭 스타일은 AboutLayout과 동일(about.css의 .about-nav 사용)
 * - children: 각 페이지 본문(공지 리스트, FAQ 등)
 */
export default function NoticeLayout({ data, children }) {
  const { pathname } = useLocation();
  const isFaq = pathname.startsWith("/faq");

  // 히어로 타이틀은 현재 탭에 맞게
  const title = isFaq ? "자주묻는 질문" : "공지 사항";

  // 탭 구성: 라벨/경로만 맞춰주면 NavTabs가 활성화 상태 처리
  const tabs = [
    { label: "공지사항", path: "/notice" },
    { label: "자주묻는 질문", path: "/faq" },
  ];

  // SubLayout(히어로) + 기존 탭 섹션(.about-nav) 그대로 재사용
  return (
    <SubLayout data={data} title={title}>
      {/* Tabs — AboutLayout과 같은 DOM 구조/클래스 */}
      <section className="about-nav">
        <div className="container">
          <NavTabs tabs={tabs} />
        </div>
      </section>

      {/* 본문 */}
      <main>{children}</main>
    </SubLayout>
  );
}
